import { render, staticRenderFns } from "./FilterLeaderboardOrbit.vue?vue&type=template&id=042e8664&scoped=true"
import script from "./FilterLeaderboardOrbit.vue?vue&type=script&lang=ts"
export * from "./FilterLeaderboardOrbit.vue?vue&type=script&lang=ts"
import style0 from "./FilterLeaderboardOrbit.vue?vue&type=style&index=0&id=042e8664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042e8664",
  null
  
)

export default component.exports